// extracted by mini-css-extract-plugin
module.exports = {"linkList":"TopicList-module--linkList--1NfGc","linkListItem":"TopicList-module--linkListItem--2oMaE","heading":"TopicList-module--heading--BZeKF"};